import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoadingService {
  static loadingStatus$: Subject<boolean> = new Subject<boolean>();
}
